<template lang="pug">
    .index
        .left.box
            .title
                span 市场雷达
            Recommend
            .title 市场短讯
            Telegraph
        .right.box
            .box-content
            .title
                span 股票地图
            .map-container(:style="{paddingBottom: '600px'}")
                GEOJSON_MAP(:height="600" :location="location" :geojson="geojson")
                .legends
                    p
                        span.red ■
                        span 上涨数量 > 下跌数量
                    p
                        span.green ■
                        span 上涨数量 < 下跌数量
                    p
                        span.gray ■
                        span 上涨下跌股票数量持平
                    p
                        span 高度：
                        span 该地区股票数量

            StockIndex

            el-tabs(v-model="rankActive" @tab-click="handleClick")
                el-tab-pane(label="个股涨幅" name="up")
                el-tab-pane(label="个股跌幅" name="down")
                el-tab-pane(label="成交量" name="volume")
                el-tab-pane(label="成交额" name="amount")
            Rank(:param="rankParam")
</template>

<script>
import GEOJSON_MAP from '../components/map/geojson.vue';
import Recommend from '../components/recommend.vue';
import StockIndex from '../components/stock-index.vue';
import Rank from '../components/rank.vue';
import China from '../components/map/100000_full.json';
import storeMixin from '../store/mixin';
import area from '@turf/area';
// import CandleStick from '../components/candlestick-mini.vue';
import Search from '../components/map/search.vue';
import Telegraph from '../components/telegraph.vue';
import intervalMixin from '../components/interval-mixin.vue';

export default {
    // components: { GEOJSON_MAP, CandleStick, Search },
    components: {
        GEOJSON_MAP,
        Search,
        Recommend,
        StockIndex,
        Rank,
        Telegraph,
    },
    mixins: [storeMixin, intervalMixin],

    name: 'Index',
    data() {
        return {
            loading: false,
            dailyLoading: false,
            dailyData: null,
            provinceData: null,
            location: null,
            rankActive: 'up',
            rankParam: { order_br: 'percent', order: 'desc' },
        };
    },
    created() {
        console.log('created');
        this.getProvinceStat();
    },
    computed: {
        geojson() {
            if (!this.provinceData) return China;
            return {
                type: 'FeatureCollection',
                features: China.features.map(feature => {
                    const code = feature.properties.adcode;
                    const provinceItem = this.provinceData[code] || {};
                    return {
                        ...feature,
                        properties: { ...feature.properties, ...provinceItem },
                    };
                }),
            };
        },
    },
    mounted() {},
    methods: {
        mixinIntervalMethods() {
            this.getProvinceStat();
        },
        async getProvinceStat() {
            if (this.loading) return;
            this.loading = true;
            try {
                const result = await this.REQUEST({
                    url: 'v2/finance/province/quote',
                });
                this.provinceData = result.data.data;
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },
        changeLocation(location) {
            this.location = location;
        },

        handleClick({ name }) {
            switch (name) {
                case 'up':
                    this.rankParam = { order_by: 'percent', order: 'desc' };
                    break;
                case 'down':
                    this.rankParam = { order_by: 'percent', order: 'asc' };
                    break;
                case 'volume':
                    this.rankParam = { order_by: 'volume', order: 'desc' };
                    break;
                case 'amount':
                    this.rankParam = { order_by: 'amount', order: 'desc' };
                    break;
                default:
                    break;
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.title
    display flex
    align-items center
    font-size 1.2em
    padding-bottom 15px
    margin-bottom 15px
    border-bottom 1px solid #23232c
a
    color #fff
.index
    display flex
    width 100%
.left
    flex-shrink 1
    flex-grow 1
    position relative
.
.cards
    margin-bottom 40px
    display flex
    justify-content space-between

.products
    position absolute
    left 20px
    right 20px
    bottom  10px
    overflow auto
    .products-container
        display flex
    dl
        position relative
        cursor pointer
        margin 20px

        img
            max-height 100px
            max-width 160px
            border-radius 10px
            box-shadow 0 0 3px 1px #333
        &.on
            img
                box-shadow 0 0 3px 1px #3b56ce
    dt
        position absolute
        width 100%
        bottom 10px
        font-size 12px
        line-height 26px
        text-align center
        user-select none
    &::-webkit-scrollbar
        width 6px
        height 6px
        background-color #F5F5F5

    /*定义滚动条轨道
    内阴影+圆角*/
    &::-webkit-scrollbar-track
        -webkit-box-shadow inset 0 0 6px rgba(0,0,0,0.3)
        border-radius 2px
        // background-color #F5F5F5
    /*定义滑块
    内阴影+圆角*/
    &::-webkit-scrollbar-thumb
        border-radius 2px
        -webkit-box-shadow inset 0 0 6px rgba(0,0,0,.3)
        // background-color #555

.aois
    margin 30px auto 0 30px
    display inline-block
.poi-search
    margin 30px 30px 0 auto
    display inline-block
    float right
.right
    width 48%
    margin-left 4%
.map-container
    position relative
.legends
    position absolute
    z-index 2
    bottom 10px
    right 10px
    font-size 12px
    background rgba(0,0,0,.1)
    padding 5px
</style>
